import React, { useState } from "react";
import {
  FaRocket,
  FaUsers,
  FaBrain,
  FaLightbulb,
  FaBullseye,
  FaBolt
} from "react-icons/fa";
import "./WhyLabsSection.css";

const features = [
  { icon: <FaRocket />,   title: "Industry-Ready Skills",    text: "Students graduate with hands-on experience in AI, robotics, and automation technologies." },
  { icon: <FaUsers />,    title: "Collaborative Learning",   text: "Students work together on real-time projects that mirror modern engineering workplaces." },
  { icon: <FaBrain />,    title: "Problem-Solving Mindset",  text: "Students build, test, fail, and innovate through practical hands-on experimentation." },
  { icon: <FaLightbulb />,title: "Innovation Culture",       text: "Modern labs encourage creativity, experimentation, and project-driven learning." },
  { icon: <FaBullseye />, title: "Career Advantage",         text: "Students gain strong portfolios and practical exposure for placements and internships." },
  { icon: <FaBolt />,     title: "Hands-on Experience",      text: "Interactive lab environments help students apply theoretical concepts practically." }
];

export default function WhyLabsSection() {
  const [formData, setFormData] = useState({
    contactPerson: "", designation: "", organisationName: "",
    organisationType: "", phone: "", email: "",
    city: "", availableSpace: "", message: "",
    source: "", customSource: ""
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      try {
  await fetch('http://localhost:5000/api/enquiry', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      formType: 'lab-setup-consultation',
      contactPerson: formData.contactPerson,
      designation: formData.designation,
      institution: formData.organisationName,
      orgType: formData.organisationType,
      phone: formData.phone,
      email: formData.email,
      city: formData.city,
      availableSpace: formData.availableSpace,
      message: formData.message,
      source: formData.source === 'Other' ? formData.customSource : formData.source,
    }),
  });
} catch (err) {
  console.log('Your backend error:', err);
}

try {
 await fetch('http://192.168.29.145:5000/api/lab', {
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify({
    name: formData.contactPerson,
    phone: formData.phone,
    email: formData.email,
    institution: formData.organisationName,
    labType: 'Lab Setup Consultation',
    orgType: formData.organisationType,
    city: formData.city,
    designation: formData.designation,
    availableSpace: formData.availableSpace,
    requirement: formData.message,
  }),
});
} catch (err) {
  console.log('Dashboard backend error:', err);
}

setSubmitted(true);
    } catch (error) {
      alert('Something went wrong. Please try again.');
    }
  };

  return (
    <section className="why-section">

      {/* HEADER */}
      <div className="why-header">
        <h2>Equipping Students for a <span>Tech-Driven Future</span></h2>
        <p>
          Hands-on AI and Robotics labs bridge the gap between classroom theory
          and real-world industry — giving students the skills, confidence, and exposure they need before they graduate.
        </p>
      </div>

      {/* GRID + IMAGE */}
      <div className="why-container">
        <div className="why-grid">
          {features.map((item, i) => (
            <div className="why-card" key={i}>
              <div className="why-icon">{item.icon}</div>
              <h4>{item.title}</h4>
              <p>{item.text}</p>
            </div>
          ))}
        </div>
        <div className="why-image">
          <img src="/assets/images/lablab.png" alt="Lab" />
          <div className="why-overlay">
            <span className="dot"></span>
            Real Students. Real Labs. Real Skills.
          </div>
        </div>
      </div>

      {/* ENQUIRY SECTION — image left + form right */}
      <div className="enquiry-section" id="lab-enquiry-form">

        {/* INTRO */}
        <div className="enquiry-intro">
          <span className="enquiry-tag">
            <span className="tag-dot"></span> GET A CONSULTATION
          </span>
          <h3>Request a Lab Setup Consultation</h3>
          <p>Submit your details and our team will contact you to help set up the right lab for your institution.</p>
        </div>

        {/* TWO COLUMN LAYOUT */}
        <div className="enquiry-layout">

          {/* LEFT IMAGE */}
          <div className="enquiry-image-side">
          <img src="/assets/images/new3d_nobg.png" alt="Lab Setup" />
          </div>

          {/* RIGHT FORM */}
          <div className="enquiry-box">
            {submitted ? (
              <div className="enquiry-success">
                <span className="success-icon">✔</span>
                <h4>Thank you for reaching out!</h4>
                <p>We've received your enquiry and will contact you within 24 hours.</p>
              </div>
            ) : (
              <form className="enquiry-form" onSubmit={handleSubmit}>

                <div className="eq-row">
                  <div className="eq-group">
                    <label>Contact Person <span className="req">*</span></label>
                    <input type="text" name="contactPerson" placeholder="Full Name" value={formData.contactPerson} onChange={handleChange} required />
                  </div>
                  <div className="eq-group">
                    <label>Designation <span className="req">*</span></label>
                    <input type="text" name="designation" placeholder="Principal / HOD / Director" value={formData.designation} onChange={handleChange} required />
                  </div>
                </div>

                <div className="eq-row full">
                  <div className="eq-group">
                    <label>Organisation Name <span className="req">*</span></label>
                    <input type="text" name="organisationName" placeholder="School / College / Institution Name" value={formData.organisationName} onChange={handleChange} required />
                  </div>
                </div>

                <div className="eq-row full">
                  <div className="eq-group">
                    <label>Organisation Type <span className="req">*</span></label>
                    <select name="organisationType" value={formData.organisationType} onChange={handleChange} required>
                      <option value="" disabled>— Select Type —</option>
                      <option value="school">School</option>
                      <option value="college">College</option>
                      <option value="university">University</option>
                      <option value="polytechnic">Polytechnic</option>
                      <option value="other">Other</option>
                    </select>
                  </div>
                </div>

                <div className="eq-row">
                  <div className="eq-group">
                    <label>Phone <span className="req">*</span></label>
                    <input type="tel" name="phone" placeholder="+91 XXXXX XXXXX" value={formData.phone} onChange={handleChange} required />
                  </div>
                  <div className="eq-group">
                    <label>Email <span className="req">*</span></label>
                    <input type="email" name="email" placeholder="official@email.com" value={formData.email} onChange={handleChange} required />
                  </div>
                </div>

                <div className="eq-row">
                  <div className="eq-group">
                    <label>City <span className="req">*</span></label>
                    <input type="text" name="city" placeholder="City" value={formData.city} onChange={handleChange} required />
                  </div>
                  <div className="eq-group">
                    <label>Available Space</label>
                    <select name="availableSpace" value={formData.availableSpace} onChange={handleChange}>
                      <option value="" disabled>— Select —</option>
                      <option value="lt500">Less than 500 sq ft</option>
                      <option value="500-1000">500 – 1000 sq ft</option>
                      <option value="1000-2000">1000 – 2000 sq ft</option>
                      <option value="gt2000">More than 2000 sq ft</option>
                    </select>
                  </div>
                </div>

                <div className="eq-row full">
                  <div className="eq-group">
                    <label>Message / Requirements</label>
                    <textarea name="message" rows={4} placeholder="Any specific requirements or questions..." value={formData.message} onChange={handleChange} />
                  </div>
                </div>

                <div className="eq-row full">
  <div className="eq-group">
    <label>How did you hear about ibots? <span className="req">*</span></label>
    <select name="source" value={formData.source} onChange={handleChange} required>
      <option value="">— Select —</option>
      {['Friend / Family Referral','School / College Recommendation','Google Search','Social Media (Instagram / Facebook)','YouTube','LinkedIn','WhatsApp','Newspaper / Magazine','Event / Hackathon','ibots Website','Other'].map((s) => (
        <option key={s} value={s}>{s}</option>
      ))}
    </select>
    {formData.source === 'Other' && (
      <input type="text" name="customSource" value={formData.customSource}
        onChange={handleChange} placeholder="Please tell us how you found us..."
        style={{ marginTop: '8px', width: '100%' }} />
    )}
  </div>
</div>

                <button type="submit" className="enquiry-submit">
                  Submit Enquiry &nbsp;→
                </button>

              </form>
            )}
          </div>
        </div>
      </div>

    </section>
  );
}